<template>
  <div class="container my-5">
    <div class="row display-flex">
      <div class="col-lg-5 col-xl-4">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col d-flex align-items-center">
                <h2 class="card-title text-truncate mb-0">Customer</h2>
              </div>
            </div>
            <h5>Contact Information</h5>
            <div class="row gx-0">
              <div class="col d-flex align-items-center text-truncate">
                <p class="text-truncate strong mb-0">
                  <i class="far fa-fw fa-building"></i>
                  <span id="cp-company"
                    ><router-link
                      :to="{ name: 'clients.details', params: { client_id: opportunity.client_id } }"
                      >{{
                        client.display_name ? client.display_name : client.company
                      }}</router-link
                    ></span
                  >
                </p>
              </div>
              <div class="col-auto">
                <a
                  href="#"
                  data-bs-toggle="tooltip"
                  title=""
                  class="btn btn-sm btn-link"
                  data-bs-original-title="Copy to clipboard"
                  aria-label="Copy to clipboard"
                  @click="copyToClipboard('cp-company')"
                  ><i class="far fa-copy"></i
                ></a>
              </div>
            </div>
            <div class="row gx-0">
              <div class="col d-flex align-items-center text-truncate">
                <p class="text-truncate strong mb-0">
                  <i class="far fa-fw fa-user-circle"></i>
                  <span id="cp-name"
                    ><router-link
                      :to="{ name: 'clients.contacts', params: { client_id: opportunity.client_id } }"
                      >{{ opportunity.contact.first_name }}
                      {{ opportunity.contact.surname }}</router-link
                    ></span
                  >
                </p>
              </div>
              <div class="col-auto">
                <a
                  href="#"
                  data-bs-toggle="tooltip"
                  title=""
                  class="btn btn-sm btn-link"
                  data-bs-original-title="Copy to clipboard"
                  aria-label="Copy to clipboard"
                  @click="copyToClipboard('cp-name')"
                  ><i class="far fa-copy"></i
                ></a>
              </div>
            </div>
            <div class="row gx-0">
              <div class="col d-flex align-items-center text-truncate">
                <p class="text-truncate mb-0">
                  <i class="far fa-fw fa-envelope"></i>
                  <span id="cp-email">{{ opportunity.contact.email }}</span>
                </p>
              </div>
              <div class="col-auto">
                <a
                  href="#"
                  data-bs-toggle="tooltip"
                  title=""
                  class="btn btn-sm btn-link"
                  data-bs-original-title="Copy to clipboard"
                  aria-label="Copy to clipboard"
                  @click="copyToClipboard('cp-email')"
                  ><i class="far fa-copy"></i
                ></a>
              </div>
            </div>
            <div class="row gx-0" v-if="opportunity.client.phone">
              <div class="col d-flex align-items-center text-truncate">
                <p class="text-truncate mb-0">
                  <i class="far fa-fw fa-phone"></i>
                  <span id="cp-phone-1">{{ opportunity.client.phone }}</span>
                </p>
              </div>
              <div class="col-auto">
                <a
                  href="#"
                  data-bs-toggle="tooltip"
                  title=""
                  class="btn btn-sm btn-link"
                  data-bs-original-title="Copy to clipboard"
                  aria-label="Copy to clipboard"
                  @click="copyToClipboard('cp-phone-1')"
                  ><i class="far fa-copy"></i
                ></a>
              </div>
            </div>
            <div class="row gx-0" v-if="opportunity.contact.mobile">
              <div class="col d-flex align-items-center text-truncate">
                <p class="text-truncate mb-0">
                  <i class="far fa-fw fa-phone"></i>
                  <span id="cp-mobile">{{ opportunity.contact.mobile }}</span>
                </p>
              </div>
              <div class="col-auto">
                <a
                  href="#"
                  data-bs-toggle="tooltip"
                  title=""
                  class="btn btn-sm btn-link"
                  data-bs-original-title="Copy to clipboard"
                  aria-label="Copy to clipboard"
                  @click="copyToClipboard('cp-mobile')"
                  ><i class="far fa-copy"></i
                ></a>
              </div>
            </div>
            <div class="row gx-0" v-if="opportunity.contact.phone">
              <div class="col d-flex align-items-center text-truncate">
                <p class="text-truncate mb-0">
                  <i class="far fa-fw fa-phone"></i>
                  <span id="cp-phone-2">{{ opportunity.contact.phone }}</span>
                </p>
              </div>
              <div class="col-auto">
                <a
                  href="#"
                  data-bs-toggle="tooltip"
                  title=""
                  class="btn btn-sm btn-link"
                  data-bs-original-title="Copy to clipboard"
                  aria-label="Copy to clipboard"
                  @click="copyToClipboard('cp-phone-2')"
                  ><i class="far fa-copy"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-7 col-xl-8">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col d-flex align-items-center">
                <h2>Opportunity Details</h2>
              </div>
              <div class="col-auto">
                <button
                  type="button"
                  class="btn btn-sm btn-link"
                  v-c-modal:modal="{}"
                >
                  <i class="far fa-pencil-alt"></i>
                  Edit
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <p>
                  <span class="data-label">Name</span>
                  {{ opportunity.formatted_name }}
                </p>
              </div>
              <div class="col-lg-6">
                <p>
                  <span class="data-label">Lead Type</span>
                  {{ opportunity.lead_type }}
                </p>
              </div>
              <div class="col-lg-6">
                <p>
                  <span class="data-label">Created</span>
                  {{ opportunity.create_at | moment("DD/MM/YYYY") }}
                </p>
              </div>
              <div class="col-lg-6">
                <p>
                  <span class="data-label">Primary Sales Person</span>
                  {{ opportunity.user ? opportunity.user.name : 'None' }}
                </p>
              </div>
              <div class="col-lg-6">
                <p>
                  <span class="data-label">Secondary Sales Person</span>
                  {{ opportunity.secondaryUser ? opportunity.secondaryUser.name : '-' }}
                </p>
              </div>
              <div class="col-6">
                <p>
                  <span class="data-label">Due Date</span>
                  <span v-if="opportunity.due_date"
                    >{{ opportunity.due_date | moment("DD/MM/YYYY") }} ({{
                      dueIn(opportunity.due_date)
                    }})</span
                  >
                  <span v-else>-</span>
                </p>
              </div>
              <div class="col-6">
                <p>
                  <span class="data-label">Expires</span>
                  <span v-if="opportunity.sign_request && opportunity.sign_request.sign_url && (opportunity.status == 'Sent' || opportunity.status == 'Viewed')"
                    >{{ expireTimeStamp }} </span
                  >
                  <span v-else>-</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <h2 class="card-title mt-5">Opportunity Notes</h2>
    <div class="card">
      <div class="card-body">
        <wysiwyg-inline
          :content="opportunity.description"
          :save="saveDescription"
        ></wysiwyg-inline>
      </div>
      <!-- /.card-body -->
    </div>
    <!-- /.card -->

    <h2 class="card-title">Company Background</h2>
    <div class="card">
      <div class="card-body">
        <wysiwyg-inline
          :content="client.notes"
          :save="saveClientNotes"
        ></wysiwyg-inline>
      </div>
      <!-- /.card-body -->
    </div>
    <!-- /.card -->

    <h2 class="card-title">Notifications Sent</h2>
    <c-data-list v-if="notificationEvents.length" :items="notificationEvents">
      <template v-slot:columns>
        <div class="col-12 col-lg-2 col-xl-2">
          <p>Type</p>
        </div>
        <div class="col-6 col-lg-7 col-xl-7">
          <p>Message</p>
        </div>
        <div class="col-6 col-lg-3 col-xl-3 text-end">
          <p>Date</p>
        </div>
      </template>
      <template v-slot:default="slotProps">
        <div class="notification-row">
        <div class="row">
          <div class="col-12 col-lg-2 col-xl-2">
            <p class="text-truncate">
              <span class="data-label d-lg-none">Type:</span>
              {{ slotProps.item.action }}
            </p>
          </div>
          <div class="col-6 col-lg-7 col-xl-7">
            <p class="text-truncate">
              <span class="data-label d-lg-none">Message:</span>
              {{ slotProps.item.message ? slotProps.item.message : '-' }}
            </p>
          </div>
          <div class="col-6 col-lg-3 col-xl-3 text-end">
            <p>
              <span class="data-label d-lg-none">Date:</span>
              {{ slotProps.item.created_at | moment("DD/MM/YYYY h:mm A") }}
            </p>
          </div>
        </div>
        </div>
      </template>
    </c-data-list>
    <div class="card" v-else>
      <div class="card-body">
        <p class="text-muted mb-0">No notifications have been sent.</p>
      </div>
      <!-- /.card-body -->
    </div>
    <!-- /.card -->

    <context-files :id="$route.params.opportunity_id"></context-files>

    <div class="row mt-3">
      <div class="col-6">
        <c-button class="me-1" variant="danger" @click="confirmArchive">
          Archive Opportunity
        </c-button>
        <c-button variant="primary" @click="confirmTemplate">
          Make Template
        </c-button>
      </div>
    </div>

    <opportunities-modal
      ref="modal"
      title="Edit Opportunity"
      :opportunity="opportunity"
      mode="edit"
    />
    <client-create-modal
      ref="clientModal"
      title="Create Client"
      :client="{}"
      mode="create"
      @created="clientCreated"
    />
    <contact-create-modal
      ref="contactModal"
      title="Create Contact"
      :contact="{}"
      @created="contactCreated"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import OpportunitiesModal from "./OpportunitiesModal";
import ContextFiles from "components/ai/ContextFiles";
import ClientCreateModal from "components/clients/ClientCreateModal";
import ContactCreateModal from "components/clients/client/ContactCreateModal";
import { WysiwygInline } from "components/form/input";
import { helperComputed, helperMethods } from "vx/modules/clients";

export default {
  $_veeValidate: {
    validator: "new", // give me my own validator scope.
  },
  components: {
    OpportunitiesModal,
    ContextFiles,
    ClientCreateModal,
    ContactCreateModal,
    WysiwygInline,
  },
  data: function () {
    return {
      editOpportunity: null,
      statuses: ["Draft", "Sent", "Approved"],
      loaded: false,
    };
  },
  computed: {
    ...helperComputed,
    ...mapState("opportunity", {
      opportunity: "single",
    }),
    notificationEvents() {
      if (!this.opportunity.sign_request || !this.opportunity.sign_request.events) {
        return [];
      }

      return this.opportunity.sign_request.events.filter((event) =>
        ['Sent', 'Reminder Sent'].includes(event.action)
      );
    },

    expireTimeStamp() {
      const regex = /\?expires=([\d]+?)&/
      const matches = regex.exec(this.opportunity.sign_request.sign_url)

      if (matches && matches.length == 2) {
        var today = moment()
        var d = moment.utc(matches[1], 'X')
        return d.format('DD/MM/YYYY') + " ("+d.diff(today, "days")+" days)"
      }

      return ""
    }
  },

  mounted: function () {
    var that = this;
  },

  methods: {
    ...helperMethods,
    ...mapActions("opportunity", {
      getOpportunity: "getSingle",
      updateSingle: "updateSingle",
      deleteSingle: "deleteSingle",
    }),

    copyToClipboard(value) {
      var copyText = document.getElementById(value)
      var textArea = document.createElement("textarea")
      textArea.value = copyText.textContent
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand("Copy")
      textArea.remove()
    },

    clientCreated(clientId) {
      this.clientId = clientId;
    },

    contactCreated(contactId) {
      this.contactId = contactId;
    },

    dueIn(dueDate) {
      var today = moment();
      var d = moment(dueDate);
      return d.diff(today, "days");
    },

    saveDescription(data) {
      return this.updateSingle({
        id: this.opportunity.id,
        payload: { description: data },
      });
    },

    saveClientNotes(data) {
      return this.updateClient({
        id: this.opportunity.client_id,
        payload: { notes: data },
      });
    },
    confirmArchive() {
      this.$swal({
        title: "Confirm Archive",
        html: "Are you sure you want to archive this opportunity",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Archive",
      }).then(
        () => {
          this.deleteSingle(this.opportunity.id).then(
            this.$router.push({ name: "opportunities.index" })
          );
        },
        function () {}
      );
    },
    confirmTemplate() {
      this.$swal({
        title: "Duplicate into Template",
        html: "Enter a template Name",
        input: "text",
        inputAttributes: {
          autocapitalize: "off",
        },
        showCancelButton: true,
        confirmButtonText: "Create",
        showLoaderOnConfirm: true,
      }).then(
        (name) => {
          return client({
            path: "/opportunities/" + this.opportunity.id + "/createTemplate",
            entity: { name: name },
            method: "POST",
          }).then(() => {
            //goto template opportunity
          });
        },
        function () {}
      );
    },
  },
};
</script>

<style scoped>
/* Non-clickable data-list rows miss the padding .list-data applies via "li a" */
.notification-row {
  padding: 16px 24px;
}

.row.display-flex {
  display: flex;
  flex-wrap: wrap;
}
.row.display-flex > [class*="col-"] {
  display: flex;
  flex-direction: column;
}
</style>
